import PropTypes from "prop-types";
import parse from "html-react-parser";
import { useApp } from "contexts";
import { AntModal } from "components/AntModal";
import { AntButton } from "components/AntButton";

export const AutoSubscribeConfirmModal = (props) => {
  const { T } = useApp();
  const { open, onCancel, onAgree } = props;
  return (
    <AntModal
      title={T("auto_subscribe_confirm_title")}
      visible={open}
      onCancel={onCancel}
      closable={false}
      width={560}
      footer={[
        <AntButton key="agree" variant="primary" onClick={onAgree} size="large" className="w-full md:w-[unset]">
          {T("Agree")}
        </AntButton>,
        <AntButton key="cancel" variant="outline" onClick={onCancel} size="large" className="w-full md:w-[unset]">
          {T("Cancel")}
        </AntButton>,
      ]}
    >
      <div className="text-base text-black text-justify">
        {parse(T("auto_subscribe_confirm_message"))}
      </div>
    </AntModal>
  );
};

AutoSubscribeConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAgree: PropTypes.func.isRequired,
};
